const GET_MAP_IT_LINK_NAVIGATION = "GET_MAP_IT_LINK_NAVIGATION";
export function setEntityMapItLinkSideMenuItem(data) {
  return {
    type: GET_MAP_IT_LINK_NAVIGATION,
    payload: data
  };
}
